import React from 'react'

import { string } from 'prop-types'

// Free-trial pill shared by the Create with AI dropdown and the user-menu
// Subscription row (Figma nav-menu). Hidden only for paying viewers
// (Generator::SubscriptionState::FREE_TRIAL_TAG_HIDDEN_TIERS, resolved into
// `showFreeTrialTag` by UnifiedNavigation). Kept as one component so the
// gradient design and markup stay in lockstep across both usages.
function FreeTrialTag({ label }) {
  return (
    <span className="unified-nav__dropdown-tag">
      <span className="unified-nav__dropdown-tag-text">{label}</span>
    </span>
  )
}

FreeTrialTag.propTypes = {
  label: string.isRequired,
}

export default FreeTrialTag
